import ReactModal from 'react-modal';
import { NavLink } from 'react-router-dom';
import { useAtom } from 'jotai';
import { AcctState } from 'stores/atoms/acctState';
import type { JSX } from 'react';
/**
 * コンテンツ作成モーダル
 */
export default function WsModalCreateContent(props: {
  setOpen: (open: boolean) => void;
  open: boolean;
}): JSX.Element {
  /* ----------------------------------------------------------------------- */
  /* 型定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* 変数定義 */
  /* ----------------------------------------------------------------------- */
  const [acctState] = useAtom(AcctState);

  /* ----------------------------------------------------------------------- */
  /* ライフサイクル関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* イベントハンドラ関数定義 */
  /* ----------------------------------------------------------------------- */
  /**
   * モーダルを閉じた時の処理
   */
  const onClose = () => {
    props.setOpen(false);
  };

  /* ----------------------------------------------------------------------- */
  /* プライベート関数定義 */
  /* ----------------------------------------------------------------------- */

  /* ----------------------------------------------------------------------- */
  /* JSX */
  /* ----------------------------------------------------------------------- */
  return (
    <>
      <ReactModal
        isOpen={props.open}
        onRequestClose={onClose}
        style={{
          overlay: {
            zIndex: 2000,
            backgroundColor: 'rgba(30, 30, 30,0.5)',
          },
          content: {
            maxWidth: '800px',
          },
        }}
        className="ReactModal__Content__Custom"
        ariaHideApp={false}
      >
        <div
          id="settings-modal"
          className="modal2 modal-content rounded-4 "
          style={{ maxWidth: 'none' }}
        >
          <div className="modal-header border-bottom-0">
            <button onClick={onClose} type="button" className="btn-close btn-circle-close">
              <img src="/img/icon/multiply.svg" alt="x" />
            </button>
          </div>
          <div className="modal-body">
            <h3 className="modal-title text-center mt-5" id="settings-modal-label">
              どの形式で作成しますか
            </h3>
          </div>
          <div className="column" style={{ marginBottom: '3rem' }}>
            <div className="col-10" style={{ margin: '1.5rem auto' }}>
              <NavLink
                to={`/ws/${acctState.company.cd}/quiz/edit`}
                className="row w-100 btn btn-common"
                style={{ display: 'flex' }}
              >
                <div className="col-3">
                  <div className="card-img">
                    <img src="/img/icon/quiz-r.png" alt="question" style={{ width: '100px' }} />
                  </div>
                </div>
                <div className="col-7 my-auto">
                  <h4 className="card-title text-start">クイズ型</h4>
                </div>
              </NavLink>
              <p className="card-text" style={{ color: 'gray' }}>
                正解・不正解を競う形式で、クイズを通じてユーザーの関心を引きます。
                リード獲得やエンゲージメント向上に効果的なコンテンツです。
              </p>
            </div>
            <div className="col-10" style={{ margin: '1.5rem auto' }}>
              <NavLink
                to={`/ws/${acctState.company.cd}/diagnosis/edit`}
                className="row w-100 btn btn-common"
                style={{ display: 'flex' }}
              >
                <div className="col-3">
                  <div className="card-img">
                    <img src="/img/icon/dia-r.png" alt="question" style={{ width: '100px' }} />
                  </div>
                </div>
                <div className="col-7 my-auto">
                  <h4 className="card-title text-start">診断型</h4>
                </div>
              </NavLink>
              <p className="card-text" style={{ color: 'gray' }}>
                タイプ別に結果を分類し、性格診断やスキルチェックを提供します。
                リード獲得に役立ち、パーソナライズされた体験でユーザーの関心を引きます。
              </p>
            </div>
            <div className="col-10" style={{ margin: '1.5rem auto' }}>
              <NavLink
                to={`/ws/${acctState.company.cd}/form/edit`}
                className="row w-100 btn btn-common"
                style={{ display: 'flex' }}
              >
                <div className="col-3">
                  <div className="card-img">
                    <img src="/img/icon/form-r.png" alt="question" style={{ width: '100px' }} />
                  </div>
                </div>
                <div className="col-7 my-auto">
                  <h4 className="card-title text-start">フォーム型</h4>
                </div>
              </NavLink>
              <p className="card-text" style={{ color: 'gray' }}>
                アンケートや申込フォームなどに活用できます。一問一答形式で回答されやすく、リード獲得やユーザー理解の向上に効果的です。
              </p>
            </div>
            <div className="col-10" style={{ margin: '1.5rem auto' }}>
              <NavLink
                to={`/ws/${acctState.company.cd}/voice_chat/edit`}
                className="row w-100 btn btn-common"
                style={{ display: 'flex' }}
              >
                <div className="col-3">
                  <div className="card-img">
                    <svg
                      width="100"
                      height="100"
                      viewBox="0 0 100 100"
                      fill="none"
                      aria-label="ボイスチャット"
                    >
                      <rect width="100" height="100" rx="7" fill="#cdcbf5" />
                      <rect x="44" y="29" width="12" height="24" rx="6" fill="#6b6a92" />
                      <path
                        d="M37 50a13 13 0 0 0 26 0"
                        stroke="#6b6a92"
                        strokeWidth="4"
                        strokeLinecap="round"
                      />
                      <line
                        x1="50"
                        y1="63"
                        x2="50"
                        y2="71"
                        stroke="#6b6a92"
                        strokeWidth="4"
                        strokeLinecap="round"
                      />
                      <line
                        x1="42"
                        y1="71"
                        x2="58"
                        y2="71"
                        stroke="#6b6a92"
                        strokeWidth="4"
                        strokeLinecap="round"
                      />
                      <path
                        d="M62 40a7 7 0 0 1 0 12"
                        stroke="#ff6600"
                        strokeWidth="3"
                        strokeLinecap="round"
                      />
                      <path
                        d="M38 40a7 7 0 0 0 0 12"
                        stroke="#ff6600"
                        strokeWidth="3"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                </div>
                <div className="col-7 my-auto">
                  <h4 className="card-title text-start">ボイスチャット型</h4>
                </div>
              </NavLink>
              <p className="card-text" style={{ color: 'gray' }}>
                音声ガイダンスと音声回答で進めるアンケート形式。設問はTTSで読み上げ、回答は録音→自動で書き起こし。読む負担なくスマホで答えられます。
              </p>
            </div>
          </div>
        </div>
      </ReactModal>
    </>
  );
}
